import { getCountries, getCountryCallingCode } from 'libphonenumber-js';

const generatePhoneCodes = () => {
  const allCodes = getCountries().map((countryCode) => {
    const callingCode = getCountryCallingCode(countryCode);
    return {
      value: countryCode,
      label: `${countryCode} (+${callingCode})`,
      callingCode: `+${callingCode}`,
    };
  });

  const veIndex = allCodes.findIndex((item) => item.value === 'VE');

  if (veIndex !== -1) {
    const veItem = allCodes.splice(veIndex, 1)[0];
    allCodes.unshift(veItem);
  }
  return allCodes;
};

const PHONE_CODES = generatePhoneCodes();

export default PHONE_CODES;
